import useOnMount from './useOnMount';

export default useOnMount;
